// function getChangedFields(before, after) {
//   console.log("Before", before, "After", after);
//   const changed = [];
//   for (const key in after) {
//     if (JSON.stringify(before[key]) !== JSON.stringify(after[key])) {
//       changed.push(key);
//     }
//   }
//   return changed;
// }

// export default getChangedFields;

function getChangedFields(before = {}, after = {}) {
  console.log("Before", before, "After", after);
  const changed = [];

  for (const key of Object.keys(after)) {
    const beforeVal = before[key];
    const afterVal = after[key];

    const isChanged =
      typeof beforeVal !== typeof afterVal ||
      JSON.stringify(beforeVal) !== JSON.stringify(afterVal);

    if (isChanged) {
      changed.push(key);
    }
  }

  return changed;
}

export default getChangedFields;
